import styled from 'styled-components'

const Action = styled.button`
    position: relative;
    overflow: hidden;
    width: 300px;
    color: #FFF;
    display: inline-block;
    padding: 16px 0px;
    border-radius: 5px;
    cursor: pointer;
    &:hover, &:disabled {
        opacity: 0.6;
    }
    background: linear-gradient(135deg, #fc3c73 0%, #fd5d87 100%);
    border: none;
    animation: pulse 3s infinite;
    animation-delay: 1s;
    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        45% {
            transform: scale(1.05);
        }
        50% {
            transform: scale(1);
        }
        55% {
            transform: scale(1.05);
        }
        100% {
            transform: scale(1);
        }
    }

    @media screen and (max-width: 767px) {
        width: ${props => props?.withConfirm ? '235px' : '300px'};
    }
`

const ActionViewStories = styled(Action)`
    background: rgb(248, 79, 127, 0.6);
`



const Text = styled.div`
    padding: 10px 0px;
    color: #fff;
`

const ActionSearchContainer = styled.div`
    position: relative;
    text-align: center;
    width: 100%;
`

const ActionBonus = styled.button`
    position: absolute;
    left: calc(50% + 170px);
    min-width: 110px;
    background-color: rgba(100,181,246,0.7) !important;
    border: none;
    border-radius: 5px;
    height: initial;
    top: 130px;
    padding-right: 0px;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 56px;
    svg {
        fill: #FFF;
    }
    &:hover {
        opacity: 0.6;
    }
`



const ActionContainer = styled.div`
    display: inline-block;
    position: relative;
    width: 100%;
    @media screen and (max-width: 767px) {
        ${ActionBonus} {
            display: none;
        }
    }
`

const ActionSearchText = styled.span`
    font-size: 13px;
    margin-left: 10px;
    background: #FFF;
    height: 100%;
    padding: 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ActionBonusMobile = styled(ActionBonus)`
    display: none;
    @media screen and (max-width: 767px) {
        display: flex !important;
        position: static;
        width: initial;
        top: auto;
        left: auto;
        right: auto;
    }
    ${ActionSearchText} {
        padding: 5px 5px;
    }
`

const SearchRow = styled.div`
    text-align: center;
    @media screen and (max-width: 767px) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px;
        & > * {
            flex-shrink: 0;
        }
    }
`

const ActionWrapper = styled.div`
    background-color: #f2f2f2;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 1px 8px 1px;
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 15px;
    margin: 0 auto;
    width: 560px;
    max-width: 90vw;
    .search__enable-camera {
        margin-top: 15px !important;
        color: var(--gray) !important;
        svg {
            color: var(--gray) !important;
        }
    }
    ${Action} {
        width: 90%;
    }
`

const ModelEarningText = styled.div`
    font-size: 14px;
    margin-bottom: 20px;
    font-weight: 500;
`

const EnableCameraContainer = styled.div`
    color: #FFF;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
`

const CameraText = styled.span`
    margin-right: 10px;
    margin-left: 5px;
`

const BackgroundContainer = styled.div`
    background: #000;
    position: absolute;
    width: 100%;
    height: 100%;
`
const Corner = styled.span`
    border: 2px solid #c1c1c1;
    position: absolute;
    top: 20px;
    left: 20px;
    width: 50px;
    height: 50px;
`

const TopLeftCorner = styled(Corner)`
    border-right: none;
    border-bottom: none;
`

const TopRightCorner = styled(Corner)`
    border-left: none;
    border-bottom: none;
    left: auto;
    right: 20px;
`

const BottomLeftCorner = styled(Corner)`
    border-right: none;
    border-top: none;
    top: auto;
    bottom: 210px;
`

const BottomRightCorner = styled(Corner)`
    border-left: none;
    border-top: none;
    top: auto;
    bottom: 210px;
    left: auto;
    right: 20px;
`

const TopLeftText = styled.span`
    position: absolute;
    top: 35px;
    left: 35px;
    color: #c1c1c1;
    font-size: 12px;
    font-weight: 600;
    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
    :after {
        content: '';
        animation: blinker 1.5s linear infinite;
        background: #e62f2f;
        width: 12px;
        height: 12px;
        display: inline-block;
        margin-left: 5px;
        border-radius: 50%;
        vertical-align: middle;
    }
`

const TopRightText = styled.span`
    position: absolute;
    top: 35px;
    right: 35px;
    color: #c1c1c1;
    font-size: 12px;
    font-weight: 600;
`

const BottomLeftText = styled.span`
    position: absolute;
    bottom: 220px;
    left: 35px;
    color: #c1c1c1;
    font-size: 12px;
    font-weight: 600;
`

const AnimationIcon = styled.img`
    width: 200px;
    max-width: 100%;
    height: auto;
    @media screen and (max-height: 750px) {
        width: 150px;
    }
    @media screen and (max-height: 650px) {
        width: 110px;
    }
    @media screen and (max-height: 550px) {
        width: 80px;
    }
`

const AnimationContainer = styled.div`
    margin-bottom: 35px;
    height: 95px;
`

const AnimationTextContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    width: 100%;
`

const AnimationText = styled.div`
    display: ${props => props.active ? 'block' : 'none'};
    color: #FFF;
    font-size: 32px;
    margin-bottom: 5px;
    opacity: 0;
    animation: slideFade 4s infinite;
    animation-delay: 0s;
    @keyframes slideFade {
        0% {
          opacity: 0;
          transform: translateY(-20px);
        }
        20% {
          opacity: 1;
          transform: translateY(0);
        }
        60% {
          opacity: 1;
          transform: translateY(0);
        }
        100% {
          opacity: 0;
          transform: translateY(20px);
        }
    }
    @media screen and (max-width: 998px) {
        font-size: 26px;
    }
`

const AnimationTextSecond = styled(AnimationText)`
    animation-delay: 0.6s;
`

const AvatarModalHost = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1200;
`

export {
    Action,
    ActionViewStories,
    ActionContainer,
    Text,
    ActionSearchContainer,
    ActionBonus,
    ActionSearchText,
    ActionWrapper,
    ModelEarningText,
    EnableCameraContainer,
    CameraText,
    BackgroundContainer,
    TopLeftCorner,
    TopRightCorner,
    BottomLeftCorner,
    BottomRightCorner,
    TopLeftText,
    TopRightText,
    BottomLeftText,
    AnimationContainer,
    AnimationText,
    AnimationTextSecond,
    AnimationTextContainer,
    AnimationIcon, ActionBonusMobile, SearchRow,
    AvatarModalHost
}